import React from "react";
import { ShieldCheck, FileCheck, CheckCircle2, Lock } from "lucide-react";
import { DOCS_IMAGE } from "../data/mock";
import { Badge } from "./ui/badge";
import { useTranslation } from "react-i18next";

export const CertificateSection = () => {
  const { t } = useTranslation();
  return (
    <section className="py-20 lg:py-28 bg-[#F5F1EA]/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Image Side */}
          <div className="order-2 lg:order-1 section-reveal">
            <div className="relative">
              <div className="rounded-3xl overflow-hidden shadow-2xl shadow-[#0C2340]/10">
                <img
                  src={DOCS_IMAGE}
                  alt="Documentos legales profesionales"
                  className="w-full h-[400px] object-cover"
                  loading="lazy"
                />
              </div>
              {/* Floating card */}
              <div className="absolute -bottom-6 -right-6 sm:right-8 bg-white rounded-2xl p-5 shadow-xl shadow-[#0C2340]/10 border border-[#E8E4DC] max-w-[240px] animate-float">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-9 h-9 rounded-lg bg-[#0C2340] flex items-center justify-center">
                    <ShieldCheck className="w-5 h-5 text-[#C8A24D]" />
                  </div>
                  <span className="font-semibold text-sm text-[#0C2340]">{t("certificate.floatingTitle")}</span>
                </div>
                <p className="text-xs text-[#7A7A8A] leading-relaxed">{t("certificate.floatingDesc")}</p>
              </div>
            </div>
          </div>

          {/* Content Side */}
          <div className="order-1 lg:order-2 section-reveal">
            <Badge className="bg-white text-[#C8A24D] border-[#E8D5A0] hover:bg-white mb-6 py-1.5 px-4 text-xs font-semibold tracking-wide uppercase">
              {t("certificate.badge")}
            </Badge>
            <h2 className="text-3xl sm:text-4xl lg:text-[42px] text-[#0C2340] leading-tight mb-6" style={{ fontFamily: "'DM Serif Display', serif" }}>
              {t("certificate.title")}
            </h2>
            <p className="text-lg text-[#4A5568] leading-relaxed mb-8">
              {t("certificate.body")} <span className="font-semibold text-[#0C2340]">{t("certificate.bodyHighlight")}</span> {t("certificate.bodySuffix")}
            </p>

            <div className="space-y-4">
              {[
                { icon: FileCheck, text: t("certificate.point1") },
                { icon: CheckCircle2, text: t("certificate.point2") },
                { icon: Lock, text: t("certificate.point3") },
              ].map((item, idx) => (
                <div key={idx} className="flex items-center gap-4 group">
                  <div className="w-10 h-10 rounded-lg bg-white flex items-center justify-center shrink-0 border border-[#E8E4DC] group-hover:border-[#C8A24D] group-hover:bg-[#F5F1EA] transition-all duration-300">
                    <item.icon className="w-5 h-5 text-[#C8A24D]" />
                  </div>
                  <p className="text-[#4A5568] text-base">{item.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CertificateSection;
